export const getSearchedResults = (state, props) => {
  let results = state.itemNameSearchReducer.searchedResults[props.name] || [];
  return results;
}

export const getSearchedResultsByIndex = (state, props, index) => {
  const results = state.itemNameSearchReducer.searchedResults[props.name] || [];
  return results[index];
};

export const getSearchFetched = (state, prop) => state.itemNameSearchReducer.params.searchFetched;
// Get loading state for specific field using prop.name as key
export const getIsFetching = (state, prop) => state.itemNameSearchReducer.loadingByField[prop.name] || false;
